import _ from '@lodash';
import { AppBar, DialogActions, DialogContent, IconButton, TextField, Toolbar, Typography } from '@material-ui/core';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as Helpers from 'app/Core/Helpers';
import * as AppActions from 'app/store/actions';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { MdClose } from 'react-icons/md';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import XAPPButton from '../../Core/Components/Button/XAPPButton';
import * as Actions from './Store/Actions/EmpresaTarefaActions';

const md = new MobileDetect(window.navigator.userAgent);

const newEmpresaTarefaState = {
    idempresatarefa: null,
    idparent: null,
    idpessoa: null,
    status: 0,
    prazo: Helpers.GetDataAtual(null, "usa") + 'T00:00',
    descricao: null,
};

class EmpresaTarefaDialog extends XAPPComponent {

    state = { ...newEmpresaTarefaState };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.EmpresaTarefa.error) {
            this.props.showMessage({
                message: this.props.EmpresaTarefa.error,
                variant: 'error'
            });
            this.props.EmpresaTarefa.error = null;
        }
        if (this.props.EmpresaTarefa.warning) {
            this.props.showMessage({
                message: this.props.EmpresaTarefa.warning,
                variant: 'warning'
            });
            this.props.EmpresaTarefa.warning = null;
        }
        if (this.props.EmpresaTarefa.info) {
            // this.props.showMessage({
            //     message: this.props.EmpresaTarefa.info,
            //     variant: 'success'
            // });
            this.props.EmpresaTarefa.info = null;
            this.props.openDialog(null);
        }

        if (prevProps.open === null && this.props.open !== null) {
            var obj = Object.assign({}, newEmpresaTarefaState, this.props.open);
            obj.idpessoa = this.props.xappRouteParams.empresa;
            obj.prazo = Helpers.GetDataAtual(null, "usa") + 'T00:00';
            this.setState(obj);
        }
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    canBeSubmitted() {
        const { prazo, descricao } = this.state;
        return (
            prazo !== null && prazo !== '' &&
            descricao !== null && descricao !== ''
        );
    }

    render() {
        const { open, openDialog, save, xappRouteParams } = this.props;
        const form = this.state;

        return (
            <XAPPDialog
                id="EmpresaTarefa"
                classes={{
                    paper: "m-24"
                }}
                open={open !== null}
                onClose={() => openDialog(null)}
                fullWidth
                fullScreen={md.mobile() !== null}
                maxWidth="sm"
            >

                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {'Novo lembrete'}
                        </Typography>
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={() => openDialog(null)}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>

                <DialogContent classes={{ root: "p-24" }}>
                    <div className="flex">
                        <TextField
                            className="mt-16 mb-16"
                            label="Prazo"
                            id="prazo"
                            name="prazo"
                            value={form.prazo}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            required
                            type="datetime-local"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                    <div className="flex">
                        <TextField
                            className="mt-16 mb-16"
                            label="Descrição"
                            id="descricao"
                            name="descricao"
                            value={form.descricao}
                            multiline
                            required
                            rows={3}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                </DialogContent>
                <AppBar position="static" elevation={3} color="textSecondary">
                    <Toolbar className="flex w-full justify-end min-h-0">
                        <DialogActions>
                            <XAPPButton
                                type="Button"
                                className="bg-green hover:bg-green text-white"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    save(form, xappRouteParams, form.idparent);
                                }}
                                disabled={!this.canBeSubmitted()}
                                iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                icon={"save"}
                                label={md.mobile() === null && md.tablet() === null ? 'Salvar' : ''}
                            />
                        </DialogActions>
                    </Toolbar>
                </AppBar>
            </XAPPDialog>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        save: Actions.save,
        remove: Actions.remove,
        showMessage: AppActions.showMessage,
        hideMessage: AppActions.hideMessage
    }, dispatch);
}

function mapStateToProps({ EmpresaTarefaApp }) {
    return {
        //formDialog  : EmpresaTarefaApp.tarefaProcessoStatusDialog,
        EmpresaTarefa: EmpresaTarefaApp,
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(EmpresaTarefaDialog);
